module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/wiki_big-fc6b87bdcbc58fcb8c3b37d2158ff413.svg";